import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
/**
 * The encryption feature is enabled when
 * 1. encryption flight is enabled, and
 * 2. user is enterprise user or premium consumer user
 */
export default function isEncryptionFeatureEnabled() {
    return (isMailFeatureEnabled('cmp-encryption') &&
        (!isConsumer() || getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox));
}
//# sourceMappingURL=isEncryptionFeatureEnabled.js.map